import * as React from 'react';
import { Component } from 'react';

import './OpenedCountriesHomeView.scss';
import { OpenedCountry } from '../../models/OpenedCountries/openedCountries';
import InfiniteScroll from 'react-infinite-scroll-component';
import i18next from 'i18next';
import Spiner from '../Shared/Spiner/Spiner';

const icon = require('../../assets/no_requests.svg');

interface CovidResultsViewProps {
    countries: OpenedCountry[];
    q: string;
    onChangeQ: (value: string) => any;
    loading: boolean;
}

interface CovidResultsViewState {
    indexesOpened: number[];
}

export default class OpenedCountriesResultsView extends Component<CovidResultsViewProps, CovidResultsViewState> {

    state = {
        indexesOpened: [-1]
    };

    componentDidMount() {
        const {onChangeQ} = this.props;
        onChangeQ('');
        window.scrollTo(0, 0);
    }

    formatter = (str: string, separator?: boolean) => {
        const linksWithText = str.match(/\[.+]\s*\(https?:\/\/[^\s]+/gi);
        if (linksWithText) {
            linksWithText.forEach(linkWithText => {
                const link = linkWithText.substring(linkWithText.indexOf('http'), linkWithText.indexOf(')'));
                const linkText = linkWithText.substring(linkWithText.indexOf('[') + 1, linkWithText.indexOf(']'));
                str = str.replace(linkWithText, `<a href=${link}>${linkText}</a>${separator ? ',' : ''}`);
            });
        }
        const searchRegExp = /\n/g;
        str = str.replace(searchRegExp, '<br/>');

        if (str.endsWith(',')) {
            str = str.substr(0, str.length - 1);
        }
        return str;
    }

    render() {
        const {countries, q, onChangeQ, loading} = this.props;
        const {indexesOpened} = this.state;
        return (
            <div className='regions'>
                {countries.length > 0 || q.length !== 0 ? <div className='regions__search'>
                    <input
                        value={q}
                        onChange={(value) => onChangeQ(value.target.value)}
                    />
                </div> : null}
                {loading ? <Spiner/>
                    :
                    countries.length > 0 ?
                        <InfiniteScroll
                            dataLength={countries.length}
                            next={() => console.log()}
                            hasMore={false}
                            endMessage={<div/>}
                        >
                            {countries.map((country, i) => <div key={i} className='regions__country'>
                                <div
                                    className='regions__country__header'
                                    onClick={() => {
                                        let newIndexesOpened = indexesOpened;
                                        indexesOpened.indexOf(i) !== -1 ? newIndexesOpened.splice(newIndexesOpened.indexOf(i), 1) : newIndexesOpened.push(i);
                                        this.setState({indexesOpened: newIndexesOpened});
                                    }}
                                >
                                    {country.flag ?
                                        <img src={country.flag.url} className='regions__country__header__flag'/> : ''}
                                    <div className='regions__country__header__name'>
                                        {country.name}
                                    </div>
                                    <img
                                        src={require('../../assets/expand_more_black_icon.svg')}
                                        className={`regions__country__header__has_more ${indexesOpened.indexOf(i) !== -1 ? 'opened' : ''}`}
                                    />
                                </div>
                                {indexesOpened.indexOf(i) !== -1
                                    ? <div className='regions__country__info'>
                                        {country.visa ? <div className='regions__country__info__filter'>
                                            <div className='regions__country__info__filter__name'>
                                                {i18next.t('visa')}
                                            </div>
                                            <div className='regions__country__info__filter__value'>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.formatter(country.visa)
                                                    }}
                                                />
                                            </div>
                                        </div> : ''}
                                        {country.how_to_get_short ? <div className='regions__country__info__filter'>
                                            <div className='regions__country__info__filter__name'>
                                                {i18next.t('how_to_get_short')}
                                            </div>
                                            <div className='regions__country__info__filter__value'>
                                                {country.how_to_get_short}
                                            </div>
                                        </div> : ''}
                                        <div className='regions__country__info__filter'>
                                            <div className='regions__country__info__filter__name'>
                                                {i18next.t('is_pcr_test_required')}
                                            </div>
                                            <div className='regions__country__info__filter__value'>
                                                {country.is_pcr_test_required ? i18next.t('needed') : i18next.t('not_needed')}
                                            </div>
                                        </div>
                                        <div className='regions__country__info__filter'>
                                            <div className='regions__country__info__filter__name'>
                                                {i18next.t('is_pcr_test_required_for_vaccinated')}
                                            </div>
                                            <div className='regions__country__info__filter__value'>
                                                {country.is_pcr_test_required_for_vaccinated ? i18next.t('take_the_test') : i18next.t('dont_take_the_test')}
                                            </div>
                                        </div>
                                        <div className='regions__country__info__filter last'>
                                            <div className='regions__country__info__filter__name'>
                                                {i18next.t('is_pcr_test_required_for_who_have_been_ill')}
                                            </div>
                                            <div className='regions__country__info__filter__value'>
                                                {country.is_pcr_test_required_for_who_have_been_ill ? i18next.t('take_the_test') : i18next.t('dont_take_the_test')}
                                            </div>
                                        </div>
                                        {country.how_to_get ? <div className='regions__country__info__description'>
                                            <div className='regions__country__info__description__name'>
                                                {i18next.t('how_to_get')}
                                            </div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: this.formatter(country.how_to_get)
                                                }}
                                            />
                                        </div> : ''}
                                        {country.entry_conditions ?
                                            <div className='regions__country__info__description'>
                                                <div className='regions__country__info__description__name'>
                                                    {i18next.t('entry_conditions')}
                                                </div>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.formatter(country.entry_conditions)
                                                    }}
                                                />
                                            </div> : ''}
                                        {country.without_pcr_test ?
                                            <div className='regions__country__info__description'>
                                                <div className='regions__country__info__description__name'>
                                                    {i18next.t('without_pcr_test')}
                                                </div>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.formatter(country.without_pcr_test)
                                                    }}
                                                />
                                            </div> : ''}
                                        {country.restrictions ? <div className='regions__country__info__description'>
                                            <div className='regions__country__info__description__name'>
                                                {i18next.t('restrictions')}
                                            </div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: this.formatter(country.restrictions)
                                                }}
                                            />
                                        </div> : ''}
                                        {country.source ? <div className='regions__country__info__description'>
                                            <div className='regions__country__info__description__name'>
                                                {i18next.t('source')}
                                            </div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: this.formatter(country.source, true)
                                                }}
                                            />
                                        </div> : ''}
                                    </div>
                                    : ''}
                            </div>)}
                        </InfiniteScroll> :
                        <div className='search-result__wrapper_error'>
                            <img src={icon}/>
                            <div className='search-result__group'>
                                <div className='not-found' style={{textAlign: 'center'}}>{i18next.t('no_results')}
                                </div>
                            </div>
                        </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/OpenedCountries/OpenedCountriesResultsView.tsx